import { FC, ReactNode } from 'react';
import { FormProvider } from 'react-hook-form';
import { usePersonalPropertyItemForm } from '../hooks';
import { PersonalPropertyItemFormContextProvider } from '../context';

interface PersonalPropertyItemFormProps {
  children?: ReactNode;
  className?: HTMLFormElement['className'];
  usePersonalPropertyItemFormReturn: ReturnType<typeof usePersonalPropertyItemForm>;
}

export const PersonalPropertyItemForm: FC<PersonalPropertyItemFormProps> = ({
  children,
  className,
  usePersonalPropertyItemFormReturn,
}) => {
  if (!usePersonalPropertyItemFormReturn) {
    return null;
  }

  const { formMethods, personalPropertyItem, householdID, onSubmit } = usePersonalPropertyItemFormReturn;

  if (!formMethods) {
    return null;
  }

  return (
    <FormProvider {...formMethods}>
      <PersonalPropertyItemFormContextProvider personalPropertyItem={personalPropertyItem} householdID={householdID}>
        <form className={className} onSubmit={formMethods.handleSubmit(onSubmit)} role={'form'}>
          {children}
        </form>
      </PersonalPropertyItemFormContextProvider>
    </FormProvider>
  );
};
